var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"introduce"},[_c('div',{staticClass:"title"},[_vm._v("授课老师——林曦")]),_vm._v(" "),_c('img',{staticClass:"intro-bg-img",attrs:{"draggable":"false","src":_vm.$images.activity_calligraphy_introduce_bg_img}})])
}
var staticRenderFns = []

export { render, staticRenderFns }